import MarkDownRenderer from '../../../../../commonComponents/MarkDownRender/MarkDownRender.Component';

export const markdownContent = `
## **Service Definition**

The **Service Definition** tab is used to load and inspect gRPC service definitions
required to invoke gRPC methods in HawkClient.

You can load service definitions using **two supported approaches**:

---

### 🔁 **Load from Server Reflection**

- Connects directly to a gRPC server
- Fetches available services and methods dynamically
- No \`.proto\` files are required locally
- Ideal when the server has **gRPC reflection enabled**

This is the fastest way to explore and test unknown gRPC services.

---

### 📂 **Load from Proto Path**

Use local protobuf files when reflection is unavailable.

Proto Path supports **two loading options**:

#### 📄 Load from File
- Select one or more specific \`.proto\` files
- Useful for small or isolated services

#### 📁 Load from Folder
- Load an entire folder containing multiple \`.proto\` files
- Automatically resolves imports between proto files
- Recommended for large or modular proto structures

---

### 📄 **What You Can Inspect**

Once loaded, HawkClient allows you to:
- View available **services and RPC methods**
- Identify **Unary**, **Server Streaming**, **Client Streaming**, and **Bidirectional Streaming** methods

`;

const GRPCServiceDefinition = () => {
    return (
        <MarkDownRenderer
            title="Service Definition"
            markDownText={markdownContent}
        />
    );
};

export default GRPCServiceDefinition;
